module.exports = __webpack_public_path__ + "img/background.f2bb5257.png";